import { SvgIcon, SvgIconProps } from '@mui/material';

interface PlusIconProps extends SvgIconProps {
  disabled?: boolean;
}

const PlusIcon = ({ disabled, ...props }: PlusIconProps) => {
  const iconColor = disabled ? 'var(--mui-palette-action-disabled)' : 'var(--mui-palette-primary-main)';
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="18" height="18" rx="1.5" fill={iconColor} stroke={iconColor} strokeWidth="2" />
        <path
          d="M10 6V14M6 10H14"
          stroke="var(--mui-palette-common-white)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default PlusIcon;
